// extracted by mini-css-extract-plugin
export var printerCard = "_an-1";
export var printerCardConfigured = "_an-2";
export var printerCardError = "_an-3";
export var printerCardsContainer = "_an-0";
export var printerIcon = "_an-8";
export var printerIconConfigured = "_an-5";
export var printerIconContainer = "_an-4";
export var printerIconError = "_an-6";
export var printerIconUnconfigured = "_an-7";
export var workstationsTableCard = "_an-9";